(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("myOrders", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/orders/myOrdersView.html",
            controller: ["accountOrdersResource", "DTOptionsBuilder", "$translate", "$scope", "$sessionStorage", "$state", "$compile", "$filter", MyOrdersCtrl],
            controllerAs: "vm"
        };
        function MyOrdersCtrl(accountOrdersResource, DTOptionsBuilder, $translate, $scope, $sessionStorage, $state, $compile, $filter) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            if ($sessionStorage.myOrdersFilter) {
                vm.dtSearch = $sessionStorage.myOrdersFilter.search;
            }
            else {
                vm.dtSearch = "";
            }
            /////////////////////////////////////////////
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                return accountOrdersResource.query().$promise;
            })
                .withOption("createdRow", function (row, data) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
                row.id = data.id;
            })
                .withOption("headerCallback", function (header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("order", [1, "desc"])
                .withPaginationType("full_numbers")
                .withOption("fnDrawCallback", function () {
                $sessionStorage.myOrdersFilter = { search: vm.dtSearch };
            })
                .withOption("rowCallback", rowCallback)
                .withBootstrap();
            vm.dtColumns = [
                {
                    "data": null,
                    "defaultContent": "",
                    "class": "control",
                    "sortable": false,
                    "targets": 0
                },
                {
                    "data": "number",
                    "title": $translate.instant("common.lists.orderNumber")
                },
                {
                    "data": "date",
                    "sortable": false,
                    "render": function (data) {
                        return moment.utc(data).local().format("MMM DD, Y h:mm:ss a");
                    },
                    "title": $translate.instant("common.lists.dateTime")
                },
                {
                    "data": "type",
                    "sortable": false,
                    "title": $translate.instant("common.lists.orderType"),
                    "class": "text-center",
                    "render": function (data) {
                        return $translate.instant("common.orderType." + data);
                    }
                },
                {
                    "data": "paymentStatus",
                    "sortable": false,
                    "class": "text-center",
                    "title": $translate.instant("common.lists.paymentStatus"),
                    "render": function (data) {
                        return $translate.instant("common.paymentStatus." + data);
                    }
                },
                {
                    "data": "paymentMethod",
                    "sortable": false,
                    "title": $translate.instant("common.lists.paymentMethod"),
                    "class": "text-center",
                    "render": function (data) {
                        return $translate.instant("common.paymentMethod.learner." + data.replace(/\s+/g, ''));
                    }
                },
                {
                    "data": "total",
                    "class": "text-right",
                    "title": $translate.instant("common.lists.total"),
                    "render": function (data, _type, full) {
                        return $filter("isoCurrency")(data, full.currency);
                    }
                }
            ];
            vm.dtInstanceCallback = function (instance) {
                vm.dtInstance = instance;
            };
            vm.rowClickHandler = function (orderId) {
                $state.go("main.myOrderDetails", { orderGuid: orderId });
            };
            function rowCallback(nRow) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    vm.rowClickHandler(nRow.id);
                });
                return nRow;
            }
            vm.search = function (value) {
                $sessionStorage.myOrdersFilter = {
                    search: vm.dtSearch
                };
                vm.dtInstance.DataTable.search(value).draw();
            };
        }
    });
}());
